import axios from 'axios';
import { handleRequest } from 'helpers/api';

const CUSTOMER_URL = `${process.env.REACT_APP_API_URL}/customer`;

const customerApi = axios.create({
  baseURL: CUSTOMER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface CustomerProfile {
  phone: string;
  alternatePhone: string;
  gender: string;
  dob: Date | null;
}

export interface CustomerAddress {
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phone?: string;
}

export interface CustomerDetails {
  fullName: string;
  email: string;
  dob: Date | null;
  gender: string;
  phone: string;
  alternatePhone: string;
  shippingAddress: CustomerAddress | null;
  billingAddress: CustomerAddress | null;
  totalOrders: number;
  totalSpent: number;
  lastOrderDate: Date | null;
  createdAt: Date | null;
}

export interface CustomerProfileAll {
  fullName: string;
  email: string;
  dob?: Date | null;
  gender?: string;
  phone?: string;
  alternatePhone?: string;
  shippingAddress: CustomerAddress | null;
  billingAddress: CustomerAddress | null;
}

export const getCustomerProfile = async () => {
  return handleRequest(customerApi.get<CustomerDetails>('/details'));
};

export const updateCustomerProfile = async (data: CustomerProfile) => {
  return handleRequest(customerApi.put('/profile', data));
};

export const updateCustomer = async (data: CustomerProfileAll) => {
  return handleRequest(customerApi.put('/profile-update', data));
};

export const updateShippingAddress = async (data: CustomerAddress) => {
  return handleRequest(customerApi.put('/shipping-address', data));
};

export const updateBillingAddress = async (data: CustomerAddress) => {
  return handleRequest(customerApi.put('/billing-address', data));
};
